exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-html-js": () => import("./../../../src/pages/html.js" /* webpackChunkName: "component---src-pages-html-js" */),
  "component---src-templates-page-template-js": () => import("./../../../src/templates/pageTemplate.js" /* webpackChunkName: "component---src-templates-page-template-js" */),
  "component---src-templates-suchergebnis-index-js": () => import("./../../../src/templates/suchergebnis/index.js" /* webpackChunkName: "component---src-templates-suchergebnis-index-js" */)
}

